const DISPATCHED_ORDERS = "DISPATCHED_ORDERS";
const DISPATCHED_ORDERS_SUCCESS = "DISPATCHED_ORDERS_SUCCESS";
const DISPATCHED_ORDERS_FAILURE = "DISPATCHED_ORDERS_FAILURE";
const CLEAR_DISPATCHED_ORDERS = "CLEAR_DISPATCHED_ORDERS";

const DispatchedOrdersSymbols = {
  DISPATCHED_ORDERS_SUCCESS,
  DISPATCHED_ORDERS_FAILURE,
  DISPATCHED_ORDERS,
  CLEAR_DISPATCHED_ORDERS,
};
export default DispatchedOrdersSymbols;
